
























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store/index.ts";

import recommendedStreams from "@/components/RecommendedStreams.vue";

import VideoComponent from "@/components/shared/VideoComponent.vue";
import Ads from "@/components/shared/Ads.vue";
import { SessionDataArray } from "@/types/interfaces";
import sessionVuexModule from "@/store/vuex-modules/getSessionData";
import Spinners from "@/components/utilities/Spinners.vue";
import SessionSwimLane from "@/components/sessions/SessionSwimLane.vue";
import layoutImagesVuexModule from "@/store/vuex-modules/layoutImages";
import featuredSection from "@/components/home/section/featuredSection.vue";
import TransparentSponsorTemplate from "@/components/home/section/TransparentSponsorTemplate.vue";
import featuredVideoVuexModule from "@/store/vuex-modules/getFeaturedVideo";
import SingleSponsorDisplay from "@/components/home/section/SingleSponsorDisplay.vue";

const layoutImagesStore = getModule(layoutImagesVuexModule);
const sessionStore = getModule(sessionVuexModule);
const featuredVideoStore = getModule(featuredVideoVuexModule);

import featuredContentVuexModule from "@/store/vuex-modules/featuredContent";
const featuredContentStore = getModule(featuredContentVuexModule);

@Component({
    components: {
        recommendedStreams,
        VideoComponent,
        "featured-attendee": () => {
            let returnResult = store.getters.getPageOptions("home").section
                ?.attendeeSwimlane?.componentToLoad;
            if (!returnResult) {
                returnResult = "AttendeeSwimLane.vue";
            }
            return import(`@/components/attendees/swimlanes/${returnResult}`);
        },
        Ads,
        SessionSwimLane,
        Spinners,
        featuredSection,
        TransparentSponsorTemplate,
        SingleSponsorDisplay
    }
})
export default class Home extends Vue {
    posterImage = "";
    prev = "";
    session = "";
    bg = "";
    color = "";
    live = "";
    // chatter = "";

    videoBackgroundImage = "";
    isLoadingVideo = true;
    isLoadingSessions = true;
    isLoadingFeaturedContent = true;
    recommendedStreamsSection = "";
    featuredSection = "";

    isFeaturedAttendeeDefaultTemplate = false;

    /**
     * Getters / computed 123 - 3456
     */
    get notProduction() {
        return Boolean("production" !== process.env.NODE_ENV);
    }

    get sectionToUse() {
        const res = this.$store.getters.getPageOptions("home").section;
        const recommendedRes = res.recommendedStreams;
        const bgResult = res.videoContainer.bgDecor;

        this.recommendedStreamsSection =
            recommendedRes.componentToLoad == ""
                ? "recommendedStreams"
                : recommendedRes.componentToLoad;

        this.featuredSection = res.featuredSolutionProvider.componentToLoad
            ? res.featuredSolutionProvider.componentToLoad
            : "featuredSection";

        this.videoBackgroundImage = bgResult
            ? `${process.env.BASE_URL}bg/${bgResult}`
            : "";

        this.isFeaturedAttendeeDefaultTemplate =
            res.attendeeSwimlane.componentToLoad || false;

        return res;
    }

    get siteClient() {
        return this.getLayoutOptions.siteName;
    }

    get recommendedSectionBg() {
        return layoutImagesStore.getLayoutImage("recommendedSection");
    }

    get featuredAttendeeSectionBg(): string {
        return layoutImagesStore.getLayoutImage("featuredAttendeeHome");
    }

    get cssVariables() {
        return this.$store.getters.cssVariables;
    }

    get homeLabel() {
        return this.$store.getters.homeLabel;
    }

    get getLayoutOptions() {
        return this.$store.getters.layoutOptions;
    }

    get sessionData(): SessionDataArray {
        return sessionStore.sessionPromos ? sessionStore.sessionPromos : [];
    }

    get featuredVideo() {
        return featuredVideoStore.featuredVideo;
    }

    get featuredContent() {
        return featuredContentStore.featuredContent;
    }

    /**
     * Lifecycle
     */

    created() {
        this.init();
    }

    /**
     * Methods
     */

    init() {
        const promises = [
            featuredVideoStore.getFeaturedVideo(),
            sessionStore.getSessionData({
                tableName: this.$store.getters.awsConfig.sessionTable,
                isDemoData: false
            }),
            featuredContentStore.getFeaturedContent()
        ];
        Promise.all(promises)
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.isLoadingVideo = false;
                this.isLoadingSessions = false;
                this.isLoadingFeaturedContent = false;
            });
    }

    bgColor(section: string) {
        if (section == "previous") {
            return this.cssVariables["--home-prev-session-bg-color"] != ""
                ? "bg-prev-session"
                : "bg-gradient";
        } else if (section == "featured-section") {
            return this.cssVariables["--home-solution-provider-bg-color"] != ""
                ? "bg-featured-solution"
                : "bg-gradient";
        } else {
            return null;
        }
    }
}
